<template>
  <div>
    <div class="search-box">
      <div class="input-item">
        <span class="label">课程标题</span>
        <Input v-model="searchParams.title" clearable placeholder="请输入" />
      </div>
      <div class="input-item">
        <span class="label">课程类型</span>
        <Select v-model="searchParams.articleType" clearable transfer filterable multiple>
          <Option :value="11">图文</Option>
          <Option :value="12">视频</Option>
          <Option :value="20">PDF</Option>
          <Option :value="23">直播</Option>
          <Option :value="25">系列视频</Option>
          <Option :value="15">图片素材</Option>
          <Option :value="16">视频素材</Option>
          <Option :value="19">Excel表格</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">关联产品</span>
        <Select :label-in-value="true" v-model="searchParams.productCode" placeholder="请选择" clearable transfer filterable multiple>
          <Option :value="product.productCode" v-for="product in productListArr" :key="product.id">{{ product.productName }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">发布时间</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
        ></DatePicker>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch(), (searchParams.date = [])">重置</Button>
      </div>
    </div>

    <div class="tab-top">
      <div class="item" :class="{ 'active-item': index == activeTabTop }" v-for="(item, index) in tabTopList" :key="index" @click="changeTabTop(item, index)">
        {{ item.name }}
      </div>
    </div>

    <div class="tab-one">
      <Tabs v-model="activeTab" @on-click="changeTabOne">
        <TabPane :label="item.name" :name="item.id" v-for="(item, i) in tabOneList" :key="i"></TabPane>
      </Tabs>
    </div>

    <div class="tab-two" v-if="tabTwoList.length">
      <div class="tab-item" v-for="(item, index) in tabTwoList" :key="index" :class="{ active: tabTwoAction == index }" @click="changeTabTwo(item, index)">
        <span>{{ item.name }}</span>
      </div>
    </div>

    <div class="selected-box" v-if="tableData.length">
      <div class="action-left">
        <div class="current-page">
          <Checkbox class="checkBox" :disabled="isAll" v-model="isOnePage" @on-change="handleCheck">当前页课程</Checkbox>
        </div>
        <div class="all-page">
          <Checkbox class="checkBox" v-model="isAll" @on-change="handleCheckAll">全部课程</Checkbox>
        </div>
        <div class="amount">
          <span
            >已选择<span class="num">{{ isAll ? total : checkItemsList.length }}</span
            >项</span
          >
        </div>
        <span class="deselect" @click="cancleSelete" v-if="isAll ? total : checkItemsList.length">取消选择</span>
      </div>
      <div class="action-right" v-if="$units.pointAction('content_6_1')">
        <div class="import" @click="importGrounding(0, true, {})">批量导入</div>
        <div class="import-release" @click="importGrounding(1, true, {})">批量导入并上架</div>
      </div>
    </div>

    <loading :isShow="listLoading" />
    <div class="table" v-if="tableData.length">
      <div class="table-container" v-for="(item, index) in tableData" :key="index">
        <div class="left">
          <Checkbox class="check" v-model="item._checked" :disabled="item._disabled" @on-change="handleCheckRow($event, item)"></Checkbox>
          <div class="cover-wrap">
            <span v-if="[25].includes(item.articleType)" class="left-tip">系列</span>
            <img v-if="[16].includes(item.articleType)" src="@/static/images/contentManage/08.png" />
            <img v-else-if="item.coverImg" :src="item.coverImg" />
            <img class="play-icon" @click="toDetaile(item)" v-if="[16, 12, 25].includes(item.articleType)" src="@/static/images/contentManage/05.png" />
          </div>

          <div class="text-box">
            <div class="title-new">
              <span class="title" @click="toDetaile(item)">{{ item.title }}</span>
              <img v-if="getTime(item.publishTime)" src="@/static/images/contentManage/09.png" />
            </div>
            <span class="desc">{{ item.articleDescribe }}</span>
            <div class="time-box">
              <div class="time">
                <span class="lable">发布时间：</span>
                <span class="value">{{ item.publishTime && item.publishTime.substr(0, 16) }}</span>
              </div>
              <!-- <div class="imports-box">
                <span class="lable">导入次数：</span>
                <span class="value">{{ item.importNums }}</span>
              </div> -->
            </div>
          </div>
        </div>
        <div class="right">
          <div class="btn details" @click="toDetaile(item)" v-if="$units.pointAction('content_6_0')">查看详情</div>
          <div class="btn import-btn hover-import" v-if="$units.pointAction('content_6_1') && item.isImport == 0" @click="importGrounding(0, false, item)">
            导入
          </div>
          <div class="btn import-release-btn block-btn" v-if="$units.pointAction('content_6_1') && item.isImport == 0" @click="importGrounding(1, false, item)">
            导入并上架
          </div>
          <div class="btn imported" v-if="item.isImport == 1 && !item.publish">已导入</div>
          <div class="btn imported" v-if="item.isImport == 1 && item.publish">已导入并上架</div>
        </div>
      </div>
    </div>
    <noData v-if="!tableData.length"></noData>

    <!-- 导入 -->
    <trainingCenterMaterialImport ref="trainingCenterRef" @reload="importReload"></trainingCenterMaterialImport>

    <!-- 详情预览 -->
    <trainingCenterMaterialDetail ref="trainingCenterDetail"></trainingCenterMaterialDetail>

    <!-- excel预览 -->
    <Modal v-model="excelModal" title="课程文件" width="650" :footer-hide="true" class="my-modal top p-b">
      <Table :columns="excelColumns" :data="excelTableData" border style="margin-top: 15px">
        <template slot-scope="{ row }" slot="action">
          <span class="table-btn" @click="downloadExcel(row)">下载</span>
        </template>
      </Table>
    </Modal>

    <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center; margin-top: 1.25rem" />
  </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import noData from '@/components/commons/noData';
import trainingCenterMaterialImport from './trainingCenterMaterialImport';
import trainingCenterMaterialDetail from './trainingCenterMaterialDetail';
import { filterTime } from '@/api/filter';
export default {
  mixins: [pageTool],
  components: {
    noData,
    trainingCenterMaterialImport,
    trainingCenterMaterialDetail
  },
  data() {
    return {
      isAll: false,
      isOnePage: false,
      tableLoading: false, //表格loading
      searchParams: {},
      productListArr: [],
      tableData: [],
      tabTopList: [],
      activeTabTop: 0,
      activeTabId: '',
      parentList: [],
      activeTab: '',
      tabOneList: [],
      checkAllGroup: [],
      totalNum: 0,
      tabTwoList: [],
      tabTwoAction: 0,
      tabTwoActionId: '',
      pageSize: 5,
      pageNum: 1,
      checkItemsList: [],
      excelModal: false,
      excelColumns: [
        {
          title: '文件名称',
          key: 'name',
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 100,
          fixed: 'right'
        }
      ],
      excelTableData: []
    };
  },
  methods: {
    async getData() {
      this.getProductList();
      await this.getClassArr();
      this.changeTabTop(this.tabTopList[0], 0);
    },

    getTime(time) {
      let nowdate = filterTime(new Date(), 'YYYY-MM-DD');
      if (filterTime(time, 'YYYY-MM-DD') == nowdate) {
        return true;
      } else {
        return false;
      }
    },

    searchAjax() {
      this.pageNum = 1;
      this.isAll = false;
      this.checkAllGroup = [];
      this.checkItemsList = [];
      this.isOnePage = false;
      this.getList();
    },

    // 获取列表参数
    getParams() {
      const params = Object.assign({}, this.searchParams);
      if (params.date && params.date.length) {
        params.startTime = params.date[0] && filterTime(params.date[0], 'YYYY-MM-DD');
        params.endTime = params.date[1] && filterTime(params.date[1], 'YYYY-MM-DD');
        delete params.date;
      } else {
        delete params.date;
      }
      params.columnIds = [this.tabTwoActionId];
      return params;
    },

    // tab分类
    getClassArr() {
      return this.$http({
        url: '/buz/courseColumn/cms/columnTree',
        type: 'GET'
      }).then(res => {
        this.tabTopList = res.data;
        // 第二级
        if (res.data && res.data[0].children) {
          this.tabOneList = res.data[0].children;
          if (this.tabOneList && this.tabOneList[0].children) {
            this.tabTwoList = this.tabOneList[0].children;
            this.tabTwoActionId = this.tabTwoList[0].id;
          } else {
            this.tabTwoActionId = this.tabOneList[0].id;
          }
        } else {
          this.tabTwoActionId = res.data[0].id;
        }
      });
    },

    // 产品
    getProductList() {
      this.$http({
        url: '/buz/productBase/read/short/list',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 9999
        }
      }).then(res => {
        this.productListArr = res.data;
      });
    },

    getList() {
      this.listLoading = true;
      this.tableData = [];
      this.$http({
        url: '/buz/course/cms/article/list',
        type: 'POST',
        data: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.getParams()
        }
      })
        .then(res => {
          res.data.forEach(item => {
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.checkItemsList.forEach(item1 => {
            res.data.map(item2 => {
              if (item2.id == item1.id) {
                item2._checked = true;
              }
            });
          });
          // 统计当前页选中的个数
          let checkPageLeng = res.data.filter(item => item._checked).length;
          if (checkPageLeng == res.data.length) {
            this.isOnePage = true;
          }

          this.tableData = res.data;
          this.total = res.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    // 切换顶级分类
    changeTabTop(item, index) {
      this.tabOneList = [];
      this.tabTwoList = [];
      this.tabTwoAction = 0;
      this.isAll = false;
      this.isOnePage = false;
      this.totalNum = 0;
      this.activeTabTop = index;
      if (item.children && item.children) {
        this.tabOneList = item.children;
        if (this.tabOneList.length && this.tabOneList[0].children) {
          this.tabTwoList = this.tabOneList[0].children;
          this.tabTwoActionId = this.tabTwoList[0].id;
          this.activeTab = this.tabOneList[0].id;
        } else {
          this.tabTwoActionId = item.children[0].id;
          this.activeTab = this.tabOneList[0].id;
        }
      } else {
        this.tabTwoActionId = item.id;
      }
      this.searchAjax();
    },

    // 切换一级分类
    changeTabOne(val) {
      this.tabTwoList = [];
      this.tabTwoAction = 0;
      this.isAll = false;
      this.isOnePage = false;
      this.totalNum = 0;
      this.checkAllGroup = [];
      if (!val) {
        this.tabTwoActionId = '';
      } else {
        this.tabOneList.map(item => {
          if (item.id == val) {
            if (item.children && item.children.length) {
              this.tabTwoList = item.children;
              this.tabTwoActionId = item.children[0].id;
            } else {
              this.tabTwoList = [];
              this.tabTwoActionId = val;
            }
          }
        });
      }
      this.searchAjax();
    },

    changeTabTwo(item, index) {
      this.tabTwoAction = index;
      this.tabTwoActionId = item.id;
      this.searchAjax();
    },

    // 全选当前页文章
    handleCheck() {
      this.isAll = false;
      if (this.isOnePage) {
        const arr = this.tableData.filter(item => item.id);
        this.checkAllGroup = arr.map(item => item.id);
        this.tableData.forEach(item => {
          item._checked = true;
        });
        // 获取所有已选的id
        let checkedIds = this.checkItemsList.map(item => item.id);
        // 循环当前页列表，去掉之前已选的数据，把未选的数据添加到选中数组中
        this.tableData.map(item => {
          if (!checkedIds.includes(item.id)) {
            this.checkItemsList.push(item);
          }
        });
      } else {
        this.checkAllGroup = [];
        this.tableData.forEach(item => {
          item._checked = false;
        });
        // 获取当前页id集合，并从已选数组中删除掉
        let tableListIds = this.tableData.map(item => item.id);
        this.checkItemsList = this.checkItemsList.filter(item => !tableListIds.includes(item.id));
      }
    },

    // 全部课程
    handleCheckAll() {
      this.isOnePage = this.isAll;
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = this.isAll;
        item._checked = this.isAll;
      });
      this.tableData = tableData;
      this.checkAllGroup = [];
      this.checkItemsList = [];
    },

    // 选中当前课程
    handleCheckRow(value, item) {
      if (value) {
        this.checkAllGroup.push(item.id);
        // 把当前已选中的数据存放到数组中
        this.checkItemsList.push(item);
        // 获取当前页选中的个数
        let len = this.tableData.filter(item => item._checked).length;
        if (len == this.tableData.length) {
          this.isOnePage = true;
        }
      } else {
        // 当前页选中数据不等于分页条页，去掉当前页选中
        this.checkAllGroup = this.checkAllGroup.filter(data => data != item.id);
        if (this.checkAllGroup.length != this.tableData.length) {
          this.isOnePage = false;
        }
        // 从已选中删除掉当前去掉选中的数据
        this.checkItemsList = this.checkItemsList.filter(data => data.id != item.id);
      }
    },

    // 取消选择
    cancleSelete() {
      this.isAll = false;
      this.isOnePage = false;
      this.totalNum = 0;
      this.checkAllGroup = [];
      this.checkItemsList = [];
      this.tableData.forEach(item => {
        item._disabled = false;
        item._checked = false;
      });
    },

    // 导入/导入并上架
    importGrounding(type, isBatch, row) {
      if (isBatch && !this.checkItemsList.length && !this.isAll) {
        this.$Message.error('请选择导入的课程');
        return;
      }
      if (this.checkAllGroup.length > 100 || (this.isAll && this.total > 100)) {
        this.$Message.error('最多只能导入100条！');
        return;
      }
      let ids = this.checkItemsList.map(item => item.id);
      this.$refs.trainingCenterRef.open(isBatch ? ids : [row.id], type, this.isAll, this.getParams());
    },

    // 导入成功
    importReload() {
      this.searchAjax();
      this.totalNum = 0;
    },

    pageChange(pageNum) {
      this.isOnePage = false;
      if (!this.isAll) {
        this.checkAllGroup = [];
        this.totalNum = 0;
      }
      this.pageNum = pageNum;
      this.getList();
    },

    // 详情预览
    toDetaile(item) {
      let row = JSON.parse(JSON.stringify(item));
      // 12:视频、16：视频素材、20：PDF、19：Excel
      if ([12, 16, 20].includes(row.articleType)) {
        if (row.attVOList.length == 1) {
          window.open(row.attVOList[0].url, '_blank');
        } else {
          this.$refs.trainingCenterDetail.open(row.attVOList, row.articleType);
        }
      } else if (row.articleType == 19) {
        if (row.attVOList.length == 1) {
          window.open(row.attVOList[0].url, '_blank');
        } else {
          this.excelModal = true;
          this.excelTableData = row.attVOList;
        }
      } else if (row.articleType == 25) {
        this.$router.push({
          path: '/contentManagement/articleManagement/videoListDetail',
          query: {
            id: row.id
          }
        });
      } else {
        window.open(row.redirectUrl, '_blank');
      }
    },
    // excel下载
    downloadExcel(row) {
      window.open(row.url, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-top {
  margin-bottom: 0.3125rem;
  height: 2.5rem;
  background: #f5f7f9;
  border-radius: 0.125rem;
  display: flex;
  .item {
    font-size: 0.9375rem;
    color: #3c464f;
    height: 2.375rem;
    padding: 0 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;
    cursor: pointer;
    &.active-item {
      margin-left: 0.125rem;
      background: #fff;
      color: #236dff;
      font-weight: bold;
    }
  }
}
.tab-one {
  position: relative;
  /deep/.ivu-tabs-nav {
    max-width: 80%;
    overflow-x: auto;
  }
  /deep/ .ivu-tabs-tab-active {
    font-weight: bold;
  }
}

.tab-two {
  display: flex;
  margin-bottom: 0.9375rem;
  .tab-item {
    margin-right: 0.9375rem;
    padding: 0.4375rem 1rem;
    background: #f5f7f9;
    border-radius: 0.125rem;
    cursor: pointer;
    span {
      font-size: 0.75rem;
      color: #727c8e;
    }
    &.active {
      background: #236dff;
      span {
        color: #ffffff;
      }
    }
  }
}

.selected-box {
  height: 3.125rem;
  background: #f5f7f9;
  padding: 0 1.25rem;
  display: flex;
  align-items: center;
  .action-left {
    display: flex;
    .current-page {
      .checkBox {
        color: #3c464f;
        font-size: 0.8125rem;
      }
    }
    .all-page {
      margin-left: 1.875rem;
      .checkBox {
        color: #3c464f;
        font-size: 0.8125rem;
      }
    }
    .amount {
      margin-left: 1.875rem;
      font-size: 0.8125rem;
      color: #727c8e;
      .num {
        color: #236dff !important;
      }
    }
    .deselect {
      margin-left: 1.125rem;
      color: #236dff;
      font-size: 0.8125rem;
      cursor: pointer;
    }
  }
  .action-right {
    display: flex;
    margin-left: auto;
    .import {
      width: 5rem;
      height: 2rem;
      border-radius: 0.125rem;
      border: 0.0625rem solid #236dff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.75rem;
      margin-right: 0.9375rem;
      color: #236dff;
      cursor: pointer;
    }
    .import-release {
      width: 7.25rem;
      height: 2rem;
      border-radius: 0.125rem;
      border: 0.0625rem solid #236dff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.75rem;
      color: #236dff;
      cursor: pointer;
    }
  }
}
.table {
  border: 0.0625rem solid #e3e5e8;
  border-bottom: none;
  .table-container {
    display: flex;
    align-items: center;
    padding: 1.375rem 1.25rem 1.25rem 1.25rem;
    border-bottom: 0.0625rem solid #e3e5e8;
    .left {
      position: relative;
      display: flex;
      align-items: center;
      .cover-wrap {
        position: relative;
        margin-right: 1.4375rem;
      }
      .left-tip {
        position: absolute;
        left: 0;
        border-radius: 0.25rem 2px 2px 2px;
        top: 0;
        background-color: #fff;
        color: #236dff;
        border: 1px solid #236dff;
        display: inline-block;
        font-size: 12px;
        padding: 2px 4px;
        line-height: 1;
      }
      .check {
        margin-right: 1.25rem;
      }
      img {
        max-width: 10.5rem;
        max-height: 7.5rem;
        object-fit: contain;
        border-radius: 0.25rem;
      }
      .play-icon {
        position: absolute;
        top: 50%;
        margin-top: -1.25rem;
        left: calc(50% - 20px);
        cursor: pointer;
      }
      .text-box {
        display: flex;
        flex-direction: column;
        margin-bottom: auto;
        .title-new {
          display: flex;
          .title {
            font-size: 1rem;
            margin-bottom: 0.375rem;
            font-weight: bold;
            text-decoration: underline;
            color: #236dff;
            cursor: pointer;
          }
          img {
            width: 17px;
            height: 20px;
            margin-left: 5px;
          }
        }
        .desc {
          font-size: 0.8125rem;
          color: #515c6f;
        }
      }
      .tag {
        display: flex;
        margin-top: 0.625rem;
        .tag-item {
          padding: 0.25rem 0.5rem;
          border-radius: 0.125rem;
          background: #ecf1fa;
          margin-right: 1.125rem;
          font-size: 0.75rem;
          color: #2e4f96;
        }
      }
      .time-box {
        display: flex;
        margin-top: 1.25rem;
        .time {
          margin-right: 2.5rem;
          font-size: 0.8125rem;
          .lable {
            color: #727c8e;
          }
          .value {
            color: #3c464f;
          }
        }
        .imports-box {
          font-size: 0.8125rem;
          .lable {
            color: #727c8e;
          }
          .value {
            color: #3c464f;
          }
        }
      }
    }
    .right {
      margin-left: auto;
      display: flex;
      flex-direction: column;
      .btn {
        width: 7.8125rem;
        height: 2.25rem;
        border-radius: 0.125rem;
        font-size: 0.8125rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        cursor: pointer;
        &.details {
          background: #236dff;
          margin-bottom: 0.9375rem;
        }
        &.import-btn {
          background: #fff !important;
          color: #236dff !important;
          border: 0.0625rem solid #236dff;
          transition: 0.4s;
        }
        &.import-btn:hover {
          background: #236dff !important;
          color: #fff !important;
          border-radius: 0rem !important;
        }
        &.import-release-btn {
          background: #fff !important;
          color: #236dff !important;
          border: 0.0625rem solid #236dff !important;
          border-radius: 0 !important;
        }
        &.import-release-btn:hover {
          background: #236dff !important;
          color: #fff !important;
          border-radius: 0rem !important;
        }
        &.imported {
          border: 0.0625rem solid #ced1d5;
          color: #a8adb7;
          cursor: default;
        }
      }
      .hover-import:hover + .block-btn {
        display: block;
      }
      .block-btn {
        display: none;
        text-align: center;
        line-height: 2.25rem;
        background: #fff !important;
        color: #236dff !important;
        border: 0.0625rem solid #236dff !important;
        border-radius: 0 !important;
      }
      .block-btn:hover {
        display: block;
      }
    }
  }
}
</style>
